import { useEffect, useState } from "react";
import { siteThumbnailUrl } from "../lib/domains";

/** Keep the previous image while an edited version's single capture finishes.
 * Retries fetch only the saved image; they never request screenshot generation. */
export function SavedPreviewImage({ buildId, fallbackBuildId, label }: {
  buildId: string | null; fallbackBuildId?: string | null; label: string;
}) {
  const [loaded, setLoaded] = useState<string | null>(null);
  const [failed, setFailed] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);
  const [fallbackFailed, setFallbackFailed] = useState<string | null>(null);
  useEffect(() => { setAttempt(0); setFailed(null); }, [buildId]);
  useEffect(() => {
    if (!buildId || failed !== buildId || attempt >= 6) return;
    const timer = window.setTimeout(() => { setAttempt(value => value + 1); setFailed(null); }, 10_000);
    return () => window.clearTimeout(timer);
  }, [buildId, failed, attempt]);
  const fallback = !loaded && failed === buildId && fallbackBuildId && fallbackBuildId !== buildId && fallbackFailed !== fallbackBuildId ? fallbackBuildId : null;
  return <>
    {loaded && <img src={siteThumbnailUrl(loaded)} alt={label} decoding="async" width={960} height={600} />}
    {buildId && buildId !== loaded && failed !== buildId && <img key={`${buildId}-${attempt}`}
      src={siteThumbnailUrl(buildId)} alt={loaded ? "" : label} aria-hidden={loaded ? true : undefined}
      loading="lazy" decoding="async" width={960} height={600} style={loaded ? { opacity: 0 } : undefined}
      onLoad={() => setLoaded(buildId)} onError={() => setFailed(buildId)} />}
    {fallback && <img src={siteThumbnailUrl(fallback)} alt={label} loading="lazy" decoding="async" width={960} height={600}
      onLoad={() => setLoaded(fallback)} onError={() => setFallbackFailed(fallback)} />}
  </>;
}
